<template>
  <div class="search_result_works result_box">
    <div class="worksList_box result_list_box">
      <template v-if="layerpageinfo.total > 0">
        <pro_list
          :list="list"
        ></pro_list>
        <!-- 分页 -->
        <div class="page_box">
          <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
        </div>
      </template>
      <div v-else class="no_search"></div>
    </div>
  </div>
</template>

<script>
import pro_list from "@/components/list_item/pro_list/pro_list.vue";
import myPage from "@/components/myPage/myPage";
export default {
  components: {
    pro_list,
    myPage
  },
  data() {
    return {
      list: [],
      layerpageinfo: {
        pageSize: 8,
        pageNo: 0,
        total: 0
      },
    };
  },
  props: {
    searchText: {
      type: String
    }
  },
  created() {
    this.search();
  },
  methods: {
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getList();
    },
    search() {
      this.layerpageinfo.pageNo = 0;
      this.getList();
    },
    getList(){
      this.api.getOpuses({ name: this.searchText ,...this.layerpageinfo}).then(res => {
        console.log(res);
        if (res.error.err_code !== 0) return;
        let list = res.obj.list;
        this.list = list.length ? list : [];
        this.layerpageinfo.total = res.obj.totalSize;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
